import axios from 'axios';
import logger from '../logger';


// Create an Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_DB_URL,
});


export const getToken = async (username, password) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_DB_URL}/api/token/`, {
      username,
      password
    }, {
      headers: { 'Content-Type': 'application/json' }
    });

    const token = response.data.access;
    const refresh = response.data.refresh;
    localStorage.setItem('access', token);
    localStorage.setItem('refresh', refresh);
    return token;
  } catch (error) {
    logger.error('Error fetching token:', error);
    throw error;
  }
};

export const refreshToken = async () => {
  try {
    const refresh = localStorage.getItem('refresh');
    const response = await axios.post(`${process.env.REACT_APP_DB_URL}/api/token/refresh/`, {
      refresh
    }, {
      headers: { 'Content-Type': 'application/json' }
    });

    const newAccessToken = response.data.access;
    localStorage.setItem('access', newAccessToken);
    return newAccessToken;
  } catch (error) {
    logger.error('Error refreshing token:', error);
    throw error;
  }
};

// Request interceptor to add the access token to headers
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refresh');

      if (!refreshToken) {
        // If no refresh token exists, treat it as session expiration
        // Clear tokens from localStorage
        localStorage.removeItem('access');
    
        // Show alert to the user
        alert('Session expired, please login again.');
    
        // Redirect to the login page
        window.location.href = '/login';  // Adjust the path to your login page
        return new Promise(() => {});  // Prevent further promise resolution
      }

      try {
        const newAccessToken = await refreshToken();
        axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (err) {
        logger.error('Token refresh failed:', err);

         // Clear tokens from localStorage
         localStorage.removeItem('access');
         localStorage.removeItem('refresh');
 
         // Show alert to the user
         alert('Session expired, please login again.');
 
         // Redirect to the login page
         window.location.href = '/login';  // Adjust the path to your login page
         return new Promise(() => {});
      }
    }
    return Promise.reject(error);
  }
);

export default api;